// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:12:40.440Z
// Property: Rena Valley Apartments (ID: 6737460151192636)
// Collections: 15 amenities, 6 floorplans (live), 17 photos, 74 POIs, 5 reviews, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192636",
  "property_external_id": "4871556",
  "property_zillow_url": "TBD",
  "property_apartments_url": "https://www.apartments.com/rena-valley-apartments-van-buren-ar/4ehbqnh",
  "property_google_business_url": "https://www.google.com/maps/place/Rena+Valley/data=!4m2!3m1!1s0x0:0xa330b4ae20ddfa76?sa=X&ved=2ahUKEwis6e7fybySAxV4mGoFHT7uLsQQ_BJ6BAg6EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321304717",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "rena-valley-apartments",
  "property_name": "Rena Valley Apartments",
  "property_website_url": "https://www.livingatrenavalley.com/",
  "property_domain": "https://www.livingatrenavalley.com/",
  "property_address": "216 Rena Rd",
  "property_full_address": "216 Rena Rd, Van Buren, AR 72956",
  "property_address_1": "216 Rena Rd",
  "property_address_2": null,
  "property_address_city": "Van Buren",
  "property_address_state": "AR",
  "property_address_zip_full": "72956-6505",
  "property_address_zip": "72956",
  "property_address_country": "US",
  "property_address_county": "Crawford County",
  "property_neighborhood_address": "Crawford County",
  "property_address_latitude": "35.4668972",
  "property_address_longitude": "-94.3646164",
  "property_email": "renavalley@rreafresidential.com",
  "property_phone": "(479) 474-4882",
  "property_call_tracking_phone": "479-336-8901",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Rena Valley Apartments in Van Buren, AR, luxurious living meets unbeatable amenities. Choose from one or two-bedroom floor plans, dive into our sparkling pool, or unwind on the roof terrace. Enjoy 24-hour access, fitness and conference rooms, planned activities, and more. Your perfect home awaits—schedule a tour today!",
  "property_long_description": "**Welcome to Rena Valley Apartments – Your Gateway to Comfort in Van Buren, AR!**\n\nDiscover the perfect blend of style, convenience, and community at Rena Valley Apartments. Our thoughtfully designed one and two-bedroom floor plans cater to diverse lifestyles and preferences, ensuring you have the ideal space to call home. \n\nAt Rena Valley, we pride ourselves on offering a wide array of premium amenities designed to enhance your living experience. Dive into relaxation at our sparkling pool or break a sweat in our state-of-the-art fitness center. Host memorable gatherings in our stylish clubhouse or unwind on our rooftop terrace, providing breathtaking views of the surrounding landscape. Enjoy peace of mind with controlled access entry and 24-hour maintenance service, ensuring your needs are always met.\n\nStay connected with complimentary community-wide Wi-Fi and take advantage of our package service for hassle-free deliveries. Our planned social activities create a vibrant community atmosphere, perfect for meeting neighbors and making new friends. For pet owners, we offer a convenient pet washing station, with pet-friendly spaces available throughout our welcoming grounds.\n\nRena Valley Apartments also caters to modern lifestyles with features like EV charging stations, bicycle storage, and walking/biking trails for your active lifestyle. With additional perks like online services, key fob entry, and on-site property management, everything you need is right at your fingertips. \n\nDon’t miss your chance to experience life at Rena Valley Apartments. Find your new home today – browse our availability or schedule a tour to visit our community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-78d3-729c-ae0c-173bfbe14cef.webp",
  "property_featured_image_media": {
    "alt_text": "Community lounge area with tables, chairs, and artwork.",
    "public_id": "019e1de2-78d3-729c-ae0c-173bfbe14cef",
    "storage_key": "property/6737460151192636/019e1de2-78d3-729c-ae0c-173bfbe14cef.webp",
    "width": 2400,
    "height": 1600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "128",
  "property_year_built": "2005",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.65625",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Each apartment may have up to 3 pets (maximum 2 dogs). No breed restrictions.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://renavalleyapartments.loftliving.com/login",
  "property_apply_now_url": "https://8754821.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-1c87-70bc-a717-19eeae3c3f8e.webp",
  "property_primary_logo_media": {
    "alt_text": "Rena Valley logo",
    "public_id": "019e1de2-1c87-70bc-a717-19eeae3c3f8e",
    "storage_key": "property/6737460151192636/019e1de2-1c87-70bc-a717-19eeae3c3f8e.webp",
    "width": 884,
    "height": 713
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-1a93-7059-9392-d55e5977e524.webp",
  "property_secondary_logo_media": {
    "alt_text": "Rena Valley logo",
    "public_id": "019e1de2-1a93-7059-9392-d55e5977e524",
    "storage_key": "property/6737460151192636/019e1de2-1a93-7059-9392-d55e5977e524.webp",
    "width": 884,
    "height": 713
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-1a93-7059-9392-d55e5977e524.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Rena Valley logo",
    "public_id": "019e1de2-1a93-7059-9392-d55e5977e524",
    "storage_key": "property/6737460151192636/019e1de2-1a93-7059-9392-d55e5977e524.webp",
    "width": 884,
    "height": 713
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e8487-dd7c-739d-afd7-96185edec950.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8487-dd7c-739d-afd7-96185edec950",
    "storage_key": "property/6737460151192636/019e8487-dd7c-739d-afd7-96185edec950.webp",
    "width": 884,
    "height": 713
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#024644",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "650 - 925",
  "property_sqft_min": "650",
  "property_sqft_max": "925",
  "property_price_range": "675 - 975",
  "property_price_min": "675",
  "property_price_max": "975",
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/people/Rena-Valley/61555315521517/",
  "property_instagram_url": "https://www.instagram.com/RenaValley_",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJGx_8OX61y4cRdvrdIK60MKM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/rena-valley-apartments-van-buren",
  "property_tiktok_url": "https://www.tiktok.com/@rena.valley.apts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Rena Valley Apartments",
  "property_home_romance_title": "Embrace Comfort and Connection at Your Dream Apartment Community",
  "property_home_amenities_blurb": "<p>Conveniently located near Interstate 40 and Interstate 540, Rena Valley Apartments is your gateway to fun and excitement in Van Buren, Arkansas. We are in close proximity to fun outdoor recreation at Lake Louemma Park and the Arkansas River. Explore what our lovely town and pet-friendly <a href=\"/floor-plans/\">apartment</a> community have to offer. From amazing local restaurants, shops, parks, and gyms, you can find incredible diamonds in the rough to experience!</p>",
  "property_home_floorplans_blurb": "<p>Located in Van Buren, AR, we offer stunning <a href=\"/floor-plans/\">1- and 2- bedroom</a> apartment homes with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Rena Valley Apartments is more than just a place to live, it is a lifestyle.</p>",
  "property_home_gallery_blurb": "At Rena Valley Apartments in Van Buren, AR, choose from spacious one- and two-bedroom floor plans designed for modern living. Enjoy amenities like a refreshing pool, clubhouse, and playground, all nestled in a smoke-free, secure environment. Picture yourself living here, where comfort meets convenience!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Van Buren, AR, Rena Valley Apartments offers one and two-bedroom floor plans perfect for any lifestyle. Immerse yourself in the vibrant neighborhood, where local favorites and hidden gems await. Uncover the enchanting charm surrounding our community—your next adventure starts just outside your door!",
  "property_home_reviews_blurb": "At Rena Valley Apartments in Van Buren, AR, our residents are our greatest advocates. One thrilled resident exclaimed, \"Rena Valley not only met my expectations, but exceeded them!\" Join a community where exceptional service and comfort come together. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>Located in Van Buren, AR, we offer stunning <a href=\"/floor-plans/\">1- and 2- bedroom</a> apartment homes with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Rena Valley Apartments is more than just a place to live, it is a lifestyle.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Rena Valley Apartments in Van Buren, AR offers stunning apartment features and <a href=\"/amenities/\">amenities</a>. Our spacious apartments for rent include walk-in closets, a washer and dryer, and a balcony or patio. On those hot summer days enjoy the shimmering swimming pool, gather in the clubhouse, and have easy access to shopping. Everything you need and want is right here at our beautiful apartment <a href=\"/neighborhood/\">community</a>.</p>",
  "property_applynow_blurb": "At Rena Valley Apartments in Van Buren, AR, embrace a vibrant lifestyle with luxurious one and two-bedroom floor plans. Enjoy amenities like a refreshing pool, state-of-the-art fitness center, and scenic roof terrace. Join our community and experience convenience, connection, and comfort—start your journey to a new home today!",
  "property_contactus_blurb": "At Rena Valley Apartments in Van Buren, AR, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Embrace comfort and convenience in your new home. Have questions? Our friendly leasing team is ready to assist you today! Reach out and let us help you find your perfect fit.",
  "property_faqs_blurb": "At Rena Valley Apartments in Van Buren, AR, choose from our thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Have questions? Our FAQs page is your go-to resource for insights about our vibrant community. Dive into the details and find your perfect home today!",
  "property_floorplans_blurb": "<p>Our one and two bedroom apartments for rent feature <a href=\"/amenities/\">amenities</a> designed with your comfort in mind. Make life easier with a dishwasher, a refrigerator, washer and dryer connections, and a washer and dryer in the home. A few of our floor plans feature air conditioning, so it will be effortless to stay cool. You can sit, relax, and stargaze on your own balcony or patio.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Welcome to Rena Valley Apartments in Van Buren, AR, where comfort meets convenience. Immerse yourself in our vibrant community with luxurious amenities, including a refreshing pool, state-of-the-art fitness center, and inviting roof terrace. Navigate your future home effortlessly using our interactive community map—your journey to the perfect apartment starts here!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Rena Valley Apartments in Van Buren, AR, one-bedroom and two-bedroom floor plans are designed for comfort and style. Share the joy of your vibrant community with friends—refer a buddy today and embrace the benefits of great neighbors. Enjoy life together in a place you love calling home!",
  "property_residentaccess_blurb": "Welcome to Rena Valley Apartments in Van Buren, AR, where your comfort takes center stage. With thoughtfully designed one and two-bedroom floor plans, you’ll find the perfect space for your lifestyle. Access your resident portal today to effortlessly manage rent payments, schedule maintenance, and enjoy seamless community living!",
  "property_reviews_blurb": "At Rena Valley Apartments in Van Buren, AR, residents rave, “Rena Valley not only met my expectations, but exceeded them!” Our dedicated staff ensures a seamless living experience, answering every question with care. Dive into our reviews and see why so many have chosen to call Rena Valley home!",
  "property_created_at": "1752257256477",
  "property_scheduletour_blurb": "At Rena Valley Apartments in Van Buren, AR, find your perfect space with our thoughtfully designed one and two-bedroom floor plans. Experience community life that feels like home; schedule a tour today and see what our residents love about calling Rena Valley home! Your ideal apartment awaits!",
  "property_thankyou_blurb": "Thank you for reaching out! At Rena Valley Apartments in Van Buren, AR, our diverse floor plans include one and two-bedroom options, designed for your comfort and style. Stay tuned—our friendly team will be in touch soon to help you find your ideal living space. Your new home awaits!",
  "property_virtualtours_blurb": "<p>At Rena Valley Apartments, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Rena Valley Apartments",
  "property_seo_title_home": "Rena Valley Apartments | Apartments in Van Buren, AR",
  "property_seo_description_home": "Experience the vibrant lifestyle at Rena Valley Apartments in Van Buren, AR, where modern living meets unmatched comfort. Choose from spacious one and two-bedroom floor plans, and indulge in a wealth of exceptional amenities—from our inviting pool and state-of-the-art fitness center to a serene rooftop terrace. Enjoy seamless online services, community events, and controlled access for your peace of mind. Whether you're unwinding in the clubhouse or taking your pet to the washing station, every detail is designed with you in mind. Your new home awaits—secure your spot today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Van Buren, AR",
  "property_seo_description_floorplans": "Find your ideal living space at Rena Valley Apartments in Van Buren, AR! With thoughtfully designed one and two-bedroom floor plans, each home offers the perfect blend of comfort and style. Dive into our range of options and envision your new lifestyle today. Browse now to secure your perfect sanctuary!",
  "property_seo_title_amenities": "Amenities | Van Buren, AR Apartments for Rent",
  "property_seo_description_amenities": "\"Experience the vibrant lifestyle at Rena Valley Apartments in Van Buren, AR. With modern one and two-bedroom floor plans, our community boasts exceptional amenities like a sparkling pool, fitness center, rooftop terrace, and welcoming clubhouse—all designed for your comfort and convenience. Enjoy features such as controlled access, online services, and a pet washing station. Immerse yourself in a community that offers planned social activities, relaxing green spaces, and energizing walking/biking trails. Discover how Rena Valley blends luxury living with everyday ease.\"",
  "property_seo_title_gallery": "Gallery | Apartments in Van Buren, AR",
  "property_seo_description_gallery": "Unveil a lifestyle of comfort and convenience at Rena Valley Apartments in Van Buren, AR. Our captivating photo gallery showcases spacious one and two-bedroom floor plans, set against a backdrop of resort-style amenities, including a pool, fitness center, and roof terrace. Imagine unwinding in our elegant clubhouse, enjoying community-wide WiFi, or hosting friends in the courtyard with grill facilities. With pet-friendly spaces, EV charging, and planned social activities, every moment is designed for relaxation and connection. Picture yourself living here—experience the vibrant lifestyle at Rena Valley!",
  "property_seo_title_virtualtours": "Virtual Tours | Rena Valley Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside Rena Valley Apartments in vibrant Van Buren, AR, where modern living meets serene escape. With thoughtfully designed one and two-bedroom floor plans, you'll find the perfect space to call home. Immerse yourself in a virtual tour of our inviting community and discover the exceptional lifestyle that awaits you. Your ideal apartment is just a click away—take the tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Rena Valley Apartments Apartments",
  "property_seo_description_interactivemap": "\"Welcome to Rena Valley Apartments in Van Buren, AR! Choose from spacious one and two-bedroom floor plans, and enjoy an array of amenities—including a refreshing pool, state-of-the-art fitness center, and inviting clubhouse. With 24-hour access, pet-friendly features, and vibrant social activities, your ideal lifestyle awaits. Use our interactive community map to find your perfect home and explore all we have to offer!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Van Buren, AR",
  "property_seo_description_neighborhood": "Uncover the hidden gems of Van Buren, AR, right outside your door at Rena Valley Apartments. From charming local eateries to bustling parks, our vibrant neighborhood offers a delightful mix of attractions. Take a stroll through the community and see what makes this area a top choice for your new home. Your adventure begins here—explore local favorites and nearby points of interest today!",
  "property_seo_title_contact": "Contact Us | Rena Valley Apartments",
  "property_seo_description_contact": "Looking for your dream apartment in Van Buren, AR? Rena Valley Apartments offers spacious one and two-bedroom floor plans designed for comfort and style. Our friendly leasing team is eager to assist you with any inquiries. Have questions? Contact us today and take the first step toward your new home!",
  "property_seo_title_faqs": "FAQs | Apartments in Van Buren, AR",
  "property_seo_description_faqs": "Uncover the lifestyle you've always wanted at Rena Valley Apartments in Van Buren, AR. Our vibrant community offers spacious one and two-bedroom floor plans alongside fantastic amenities like a refreshing pool, state-of-the-art fitness center, and a stunning roof terrace. Enjoy 24-hour access, on-site maintenance, and planned social activities that foster connections with your neighbors. Curious about living here? Let our Frequently Asked Questions page guide you through your inquiries and help you envision your new home today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Van Buren, AR",
  "property_seo_description_reviews": "\"At Rena Valley Apartments in Van Buren, AR, our vibrant community offers more than just stylish one and two-bedroom floor plans. Dive into luxury with top-notch amenities like a refreshing pool, fitness center, and rooftop terrace. Enjoy seamless convenience with controlled access, online services, and on-site maintenance. Don’t just take our word for it—see what our residents love about life here! Join our community and uncover the ultimate living experience.\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Van Buren, AR",
  "property_seo_description_applynow": "Unlock a lifestyle of comfort and convenience at Rena Valley Apartments in Van Buren, AR. With spacious one and two-bedroom floor plans, indulgent amenities like a refreshing pool, state-of-the-art fitness center, and a serene roof terrace, every day feels like a retreat. Enjoy the perks of community-wide WiFi, online services, and planned social activities, all while having peace of mind with 24-hour access and controlled entry. Your perfect blend of relaxation and modern living awaits—find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Rena Valley Apartments",
  "property_seo_description_residentaccess": "Unlock the convenience of your home at Rena Valley Apartments in Van Buren, AR. Seamlessly manage your living experience—pay rent, schedule maintenance, and connect with your community—all in one place. Your resident portal awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Rena Valley Apartments",
  "property_seo_description_referafriend": "\"Great friends make life brighter at Rena Valley Apartments in Van Buren, AR! Share the joy of community living and refer a friend today. Enjoy perks and fabulous amenities in a welcoming environment where friendships flourish.\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Rena Valley Apartments",
  "property_seo_description_scheduletour": "\"Unlock the doors to your dream home at Rena Valley Apartments in Van Buren, AR! Experience modern living in a vibrant community. Dive into your future—schedule a tour today and see what awaits!\"",
  "property_seo_title_privacy": "Privacy Policy | Rena Valley Apartments",
  "property_seo_description_privacy": "\"At Rena Valley Apartments in Van Buren, AR, your privacy matters. Delve into our commitment to protecting your personal information and ensuring your peace of mind. Curious about how we safeguard your data? View our privacy policy for all the details!\"",
  "property_seo_title_accessibility": "Website Accessibility | Rena Valley Apartments",
  "property_seo_description_accessibility": "\"At Rena Valley Apartments in Van Buren, AR, we prioritize digital accessibility for everyone. Our commitment to creating an inclusive online experience ensures that all residents and visitors can effortlessly navigate our community. Join us in fostering a welcoming environment where everyone feels at home.\"",
  "property_seo_title_sitemap": "Sitemap | Rena Valley Apartments",
  "property_seo_description_sitemap": "\"Navigate your way to the perfect home at Rena Valley Apartments in Van Buren, AR. Our sitemap guides you through a variety of amenities and floor plans designed for modern living. Uncover the lifestyle that awaits you today!\"",
  "property_seo_title_thankyou": "Thank You | Rena Valley Apartments",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Rena Valley Apartments! We're excited to help you find your perfect home in the heart of Van Buren, AR. Stay tuned as a member of our team will be in touch soon to answer your questions and guide you on your journey to comfortable, modern living.\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Van Buren, AR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293658242",
  "amenities": [
    {
      "id": "ec_c4b1e3109bcca52fb6c2696a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "Amenity 'Clubhouse' is listed under community amenities on the website.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bbeece77c6e1ccc5598153cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Easy Access to Freeways",
      "amount": "false",
      "description": "Amenity 'Easy Access to Freeways' appears in the community list.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9ee4aeabff43128d737f626",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Easy Access to Shopping",
      "amount": "false",
      "description": "Amenity 'Easy Access to Shopping' appears in the community list.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7eec25fa12aec7d602013fc7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "Amenity 'Laundry Facility' is listed under community amenities.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_431b719c97a5d7d1d1ef00d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "On‑site Maintenance",
      "amount": "false",
      "description": "Amenity 'On‑site Maintenance' (styled as 'On-site Maintenance') is listed.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8523f762e71599380aeec429",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "Amenity 'Resident Events' is listed under community amenities.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7654c778e5f8572796c05e2f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "Amenity 'Shimmering Swimming Pool' is listed under community amenities.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e22c38b99853ae9afc984755",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning*",
      "amount": "false",
      "description": "Amenity 'Air Conditioning*' (with asterisk) is listed under apartment features.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b6f89558dc03bca922f6ec0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "Amenity 'Balcony or Patio' is listed under apartment features.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9379e71305474d6093f113a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "Amenity 'Ceiling Fans' is listed under apartment features.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7069a005727d2282ea2f4b13",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "Amenity 'Dishwasher' is listed under apartment features.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3990e74cbc44f4be78defd93",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "Amenity 'Refrigerator' is listed under apartment features.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae7155a0e8f8ad8e9d011a9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "Amenity 'Walk‑in Closets' (styled 'Walk-in Closets') is listed under apartment features.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_166c0b4af81e79fbe237aa35",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "Amenity 'Washer and Dryer Connections' is listed under apartment features.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_240a444f620e798ab1ca1c39",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer in Home",
      "amount": "false",
      "description": "Amenity 'Washer and Dryer in Home' is listed under apartment features.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b794fd50-fd21-4cec-a713-4df1d9b4f250",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/01a06dc6-017a-759a-97c7-16464a32cb23.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "01a06dc6-017a-759a-97c7-16464a32cb23",
        "storage_key": "property/6737460151192636/01a06dc6-017a-759a-97c7-16464a32cb23.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and umbrellas. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a28c02a2-de64-40d3-abed-ba2b97afedc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/01a06dc5-fedb-741e-8925-dc737d338ca5.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "01a06dc5-fedb-741e-8925-dc737d338ca5",
        "storage_key": "property/6737460151192636/01a06dc5-fedb-741e-8925-dc737d338ca5.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling blue swimming pool, surrounded by comfortable lounge chairs and umbrellas. A perfect spot for relaxation and fun.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_10d72363-c21d-4f35-ac63-93c10f171f93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/01a06dc5-ff25-729f-95b6-58a5e9d1da17.webp",
      "image_media": {
        "alt_text": "Spacious living room with modern furniture, large TV, and abstract art.",
        "public_id": "01a06dc5-ff25-729f-95b6-58a5e9d1da17",
        "storage_key": "property/6737460151192636/01a06dc5-ff25-729f-95b6-58a5e9d1da17.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this stylish apartment living room, featuring plush seating, a large flat-screen TV, and contemporary decor.",
      "link": "",
      "alt_text": "Spacious living room with modern furniture, large TV, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_26fefb6a-717f-451b-9da9-d9234a332e0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/01a06ddd-1568-77bd-a844-868ad1824c03.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and dining area.",
        "public_id": "01a06ddd-1568-77bd-a844-868ad1824c03",
        "storage_key": "property/6737460151192636/01a06ddd-1568-77bd-a844-868ad1824c03.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy a comfortable and stylish living space with this beautifully appointed apartment, featuring a large sectional sofa, elegant coffee table, and a separate dining area perfect for entertaining.",
      "link": "",
      "alt_text": "Spacious living room with a sectional sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e4671027-08e5-42a4-961f-30081ac438a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/01a06ddd-1827-7039-83b5-3b57e2012f0f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark brown cabinets, black appliances, and white countertops.",
        "public_id": "01a06ddd-1827-7039-83b5-3b57e2012f0f",
        "storage_key": "property/6737460151192636/01a06ddd-1827-7039-83b5-3b57e2012f0f.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark brown cabinetry, sleek black appliances, and ample white countertop space for all your cooking needs.",
      "link": "",
      "alt_text": "Modern kitchen with dark brown cabinets, black appliances, and white countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1421fd9c-c060-4d3c-af00-258fb440498f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/01a06ddd-15a3-703f-aecd-3d483f914b10.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark brown cabinets, white countertops, black appliances, and a striped rug.",
        "public_id": "01a06ddd-15a3-703f-aecd-3d483f914b10",
        "storage_key": "property/6737460151192636/01a06ddd-15a3-703f-aecd-3d483f914b10.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience seamless cooking and entertaining in this beautifully appointed kitchen, featuring ample cabinet space and modern black appliances.",
      "link": "",
      "alt_text": "Modern kitchen with dark brown cabinets, white countertops, black appliances, and a striped rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a893cee3-6990-475d-823f-488cc9b2e862",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/01a06ddd-1638-7305-af63-5843ce27830b.webp",
      "image_media": {
        "alt_text": "Modern living room with a sofa, chairs, coffee table, and TV.",
        "public_id": "01a06ddd-1638-7305-af63-5843ce27830b",
        "storage_key": "property/6737460151192636/01a06ddd-1638-7305-af63-5843ce27830b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and inviting living room, perfect for relaxation and entertainment. Features a comfortable sofa, stylish armchairs, and a modern entertainment center.",
      "link": "",
      "alt_text": "Modern living room with a sofa, chairs, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35a667be-ccab-4d82-bb99-a3031a4fa309",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/01a06dc5-fe32-727a-a8cf-a860e86f4346.webp",
      "image_media": {
        "alt_text": "Lounge area with tables and chairs.",
        "public_id": "01a06dc5-fe32-727a-a8cf-a860e86f4346",
        "storage_key": "property/6737460151192636/01a06dc5-fe32-727a-a8cf-a860e86f4346.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stylish lounge area with comfortable seating, tables, and decorative art, perfect for residents to relax or socialize.",
      "link": "",
      "alt_text": "Lounge area with tables and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9980490d-537f-448e-8541-01b81bafedc5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/01a06dc6-02a0-733f-95f0-253565d51092.webp",
      "image_media": {
        "alt_text": "Dining area with tables and chairs in a multifamily property.",
        "public_id": "01a06dc6-02a0-733f-95f0-253565d51092",
        "storage_key": "property/6737460151192636/01a06dc6-02a0-733f-95f0-253565d51092.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy communal dining spaces with stylish tables and chairs in this multifamily property.",
      "link": "",
      "alt_text": "Dining area with tables and chairs in a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39585403-d2e4-49a9-b40b-d6dbc3b6b907",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/01a06dc6-01f1-767b-b522-305a08bd82e7.webp",
      "image_media": {
        "alt_text": "Fenced dog park with agility equipment like a tunnel and a paw-print bench.",
        "public_id": "01a06dc6-01f1-767b-b522-305a08bd82e7",
        "storage_key": "property/6737460151192636/01a06dc6-01f1-767b-b522-305a08bd82e7.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Our dedicated dog park provides a safe and fun space for your furry friends to play and socialize, complete with agility equipment.",
      "link": "",
      "alt_text": "Fenced dog park with agility equipment like a tunnel and a paw-print bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16b6d73b-431a-47db-9270-dbe672a7275b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e8485-9599-701e-a2b1-6dab986cdeb4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables, with apartment buildings in the background.",
        "public_id": "019e8485-9599-701e-a2b1-6dab986cdeb4",
        "storage_key": "property/6737460151192636/019e8485-9599-701e-a2b1-6dab986cdeb4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and tables for your enjoyment. The surrounding apartment buildings offer a serene backdrop.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_84007d30-3c1b-402b-957c-d42602d0e566",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e8485-9140-77dd-a6c0-acdc92792409.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment building in background.",
        "public_id": "019e8485-9140-77dd-a6c0-acdc92792409",
        "storage_key": "property/6737460151192636/019e8485-9140-77dd-a6c0-acdc92792409.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment building in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_af324adc-d196-4c5c-828a-053309c8bf18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e8485-6134-705c-b3e6-2e3ee1db9277.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of an apartment building.",
        "public_id": "019e8485-6134-705c-b3e6-2e3ee1db9277",
        "storage_key": "property/6737460151192636/019e8485-6134-705c-b3e6-2e3ee1db9277.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, complete with comfortable lounge chairs and umbrellas for shade. The perfect spot to soak up the sun and enjoy the outdoors.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of an apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d2c4e9b9-fe82-4f3c-b089-9dfa261be6dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e8485-4c97-71aa-b778-b8d5cb46aa19.webp",
      "image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and a brick building.",
        "public_id": "019e8485-4c97-71aa-b778-b8d5cb46aa19",
        "storage_key": "property/6737460151192636/019e8485-4c97-71aa-b778-b8d5cb46aa19.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, complete with comfortable lounge chairs for relaxation.",
      "link": "",
      "alt_text": "Sparkling outdoor swimming pool with lounge chairs and a brick building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6e42506d-9999-4718-b06d-1ad2d6d47682",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e8485-a6c0-773d-8201-e68b5e471d2e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with stairs and green bushes.",
        "public_id": "019e8485-a6c0-773d-8201-e68b5e471d2e",
        "storage_key": "property/6737460151192636/019e8485-a6c0-773d-8201-e68b5e471d2e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring external staircases, well-maintained green bushes, and a pathway.",
      "link": "",
      "alt_text": "Exterior view of apartment building with stairs and green bushes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_12adeebf-2bca-4e5f-bdc7-06fb11449681",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e8485-a922-7457-a2d9-7d6816772dab.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with stairs and balconies.",
        "public_id": "019e8485-a922-7457-a2d9-7d6816772dab",
        "storage_key": "property/6737460151192636/019e8485-a922-7457-a2d9-7d6816772dab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring balconies, staircases, and well-maintained landscaping, offering a glimpse of the community's architecture.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with stairs and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba4d6d6f-2302-4845-b314-72625656b8d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e8485-6720-7258-9eef-028243f92faf.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with stairs and balconies.",
        "public_id": "019e8485-6720-7258-9eef-028243f92faf",
        "storage_key": "property/6737460151192636/019e8485-6720-7258-9eef-028243f92faf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment buildings with well-maintained exteriors, featuring external staircases and private balconies, set amidst lush green lawns.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with stairs and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_716ba295-6a60-4315-9ba2-e08c33a0eb54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Donut Palace",
      "poi_type": "Restaurants",
      "poi_address": "1514 Fayetteville Rd Ste J, Van Buren, AR 72956, USA",
      "poi_short_description": "Light, fluffy donuts, kolaches and pancakes are dished up in this laid-back bakery, along with coffee.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-7b25-712d-80e9-cef3bf0b5373.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-7b25-712d-80e9-cef3bf0b5373",
        "storage_key": "property/6737460151192636/019e1de3-7b25-712d-80e9-cef3bf0b5373.webp",
        "width": 1224,
        "height": 1227
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10496176145651611395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donut-palace",
      "poi_latitude": "35.4578063",
      "poi_longitude": "-94.3561901",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-689-5030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWR3GKQi1y4cRAzd-5ZfoqZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_69bd040b-672f-48e3-9cc3-8c982998c9b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "1929 Fayetteville Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "Freshly prepared fast food eatery specializing in chicken sandwiches plus a breakfast menu.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de1-f06b-74e8-a5dd-f4d95899ceca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-f06b-74e8-a5dd-f4d95899ceca",
        "storage_key": "property/6737460151192636/019e1de1-f06b-74e8-a5dd-f4d95899ceca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ar/van-buren-ar?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=307888100728308385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.46453140000001",
      "poi_longitude": "-94.3569262",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-689-4222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHYCiWgC1y4cRoQJ7qpjWRQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_7a969abc-f228-449d-a455-957dfb59ff4c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Waffle House",
      "poi_type": "Restaurants",
      "poi_address": "1507 Fayetteville Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "Simple chain spot offering American diner fare & all-day breakfast, including signature waffles.",
      "poi_long_description": "Simple chain spot offering American diner fare & all-day breakfast, including signature waffles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-851d-72b5-a881-50b7f83550f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-851d-72b5-a881-50b7f83550f4",
        "storage_key": "property/6737460151192636/019e1de3-851d-72b5-a881-50b7f83550f4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.wafflehouse.com/vanburen-ar-2221",
      "poi_directions_map_url": "https://maps.google.com/?cid=3994779612093432926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waffle-house",
      "poi_latitude": "35.4575291",
      "poi_longitude": "-94.3570549",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-474-1536",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZCA0wm1y4cRXkTNVuROcDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_4e32c5ac-f42f-4ba0-82c9-8a2808e17ee6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Burger King",
      "poi_type": "Restaurants",
      "poi_address": "1914 Fayetteville Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "Well-known fast-food chain serving grilled burgers, fries & shakes.",
      "poi_long_description": "Well-known fast-food chain serving grilled burgers, fries & shakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-812a-71fe-8322-39aa54e3de1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-812a-71fe-8322-39aa54e3de1f",
        "storage_key": "property/6737460151192636/019e1de3-812a-71fe-8322-39aa54e3de1f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://burgerking.com/store-locator/store/13308",
      "poi_directions_map_url": "https://maps.google.com/?cid=18254644462713125716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burger-king",
      "poi_latitude": "35.4650643",
      "poi_longitude": "-94.356029",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-410-3303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SIZG6C1y4cRVDsR7WuGVf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_838b4752-8c4d-4805-8b6e-d1dd2e1f66c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Golden Wok Chinese Buffet",
      "poi_type": "Restaurants",
      "poi_address": "2308 Fayetteville Rd Ste 500, Van Buren, AR 72956, USA",
      "poi_short_description": "Casual establishment specializing in Asian cuisine with a buffet, ice cream machine and turtles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-8057-75ed-8c67-83601e5f1a52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-8057-75ed-8c67-83601e5f1a52",
        "storage_key": "property/6737460151192636/019e1de3-8057-75ed-8c67-83601e5f1a52.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.goldenwokvanburen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13879460829712340002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-wok-chinese-buffet",
      "poi_latitude": "35.4711271",
      "poi_longitude": "-94.35486",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-471-7888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzaNggJ61y4cRItTzjBbAncA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_abd470a2-2883-42bc-9593-8dbd4a2a5716",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Saku Saku Hibachi Grill",
      "poi_type": "Restaurants",
      "poi_address": "1402 Fayetteville Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "Casual eatery known for hibachi and sushi, along with steak, shrimp and chicken options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-8640-71be-9fe9-4cb4c210ed11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-8640-71be-9fe9-4cb4c210ed11",
        "storage_key": "property/6737460151192636/019e1de3-8640-71be-9fe9-4cb4c210ed11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/sakusakuonwheels/?ref=content_filter",
      "poi_directions_map_url": "https://maps.google.com/?cid=914062529130566372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saku-saku-hibachi-grill",
      "poi_latitude": "35.4545203",
      "poi_longitude": "-94.3563725",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-276-3331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZS191si1y4cR5JJS_wZnrww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_901908c9-c33d-487c-b569-c179f68961eb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Las Fresas Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "613 N Plaza Ct, Van Buren, AR 72956, USA",
      "poi_short_description": "Tacos, fajitas, and other Mexican favorites served in a relaxed space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de1-eae6-767d-adf2-24347fc99291.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-eae6-767d-adf2-24347fc99291",
        "storage_key": "property/6737460151192636/019e1de1-eae6-767d-adf2-24347fc99291.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lasfresasmexicangrillar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14408289811312982501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "las-fresas-mexican-grill",
      "poi_latitude": "35.4604218",
      "poi_longitude": "-94.3540238",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-474-2580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJryHcts61y4cR5bkwuD6H9Mc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_08c05b2b-afa4-4a7e-9397-936d32d84831",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "El Lorito Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "511 Broadway St, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-7e2a-761d-b6d7-ce4a283912fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-7e2a-761d-b6d7-ce4a283912fc",
        "storage_key": "property/6737460151192636/019e1de3-7e2a-761d-b6d7-ce4a283912fc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://qrco.de/elloritomenu",
      "poi_directions_map_url": "https://maps.google.com/?cid=6911211195749673603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-lorito-mexican-restaurant",
      "poi_latitude": "35.4336606",
      "poi_longitude": "-94.3525433",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-410-2463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1THhQle0y4cRg6pcIveN6V8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_1147f91f-8642-404e-8b96-7dd4cf7941dd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "La Huerta Authentic Mexican Food",
      "poi_type": "Restaurants",
      "poi_address": "1915 Main St, Van Buren, AR 72956, USA",
      "poi_short_description": "Mexican comfort food such as tacos and fajitas offered in an informal setting with a kids' menu.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-8080-7055-9bf9-0a5e0c92ac3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-8080-7055-9bf9-0a5e0c92ac3e",
        "storage_key": "property/6737460151192636/019e1de3-8080-7055-9bf9-0a5e0c92ac3e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://themenustar6.com/webspace/menus.php?code=orderlahuertaauthenticmexicanfood.com",
      "poi_directions_map_url": "https://maps.google.com/?cid=17374579903462586918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-huerta-authentic-mexican-food",
      "poi_latitude": "35.436854",
      "poi_longitude": "-94.3387507",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-471-0113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ00wwUda1y4cRJjqHI17oHvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_4261e794-d32a-48a5-9734-504fadef08be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Pasta Grill & Catering",
      "poi_type": "Restaurants",
      "poi_address": "810 Main St, Van Buren, AR 72956, USA",
      "poi_short_description": "Steaks, seafood, and traditional Italian dishes offered in a comfortable atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-7b6a-77c2-87e7-c404dfcb216d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-7b6a-77c2-87e7-c404dfcb216d",
        "storage_key": "property/6737460151192636/019e1de3-7b6a-77c2-87e7-c404dfcb216d.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.pastagrillrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7881313434446093473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pasta-grill--catering",
      "poi_latitude": "35.436723",
      "poi_longitude": "-94.352084",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-262-6225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fZKUfi1y4cRoVysx88MYG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_38058a9d-1aa1-45b2-97e4-3143102dcfff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Frank's Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "525 N Plaza Dr, Van Buren, AR 72956, USA",
      "poi_short_description": "Casual eatery preparing hearty portions of pizza, pasta & other Italian specialties.",
      "poi_long_description": "Casual eatery preparing hearty portions of pizza, pasta & other Italian specialties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-818b-71f3-8bd6-ead660f4e7c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-818b-71f3-8bd6-ead660f4e7c0",
        "storage_key": "property/6737460151192636/019e1de3-818b-71f3-8bd6-ead660f4e7c0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://franks-restaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8297522536528330628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "franks-italian-restaurant",
      "poi_latitude": "35.4604044",
      "poi_longitude": "-94.3550681",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-474-7778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaeC3EaC1y4cRhL-R6ci4JnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_60d6e717-e429-403f-a3be-2fb347f579f8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "The Vault 1905 Sports Grill",
      "poi_type": "Restaurants",
      "poi_address": "624 Main St, Van Buren, AR 72956, USA",
      "poi_short_description": "Casual spot for burgers, ribs, steak and pizza served in an old bank building.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de1-f13d-77a9-bc2d-1a26a6889d59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-f13d-77a9-bc2d-1a26a6889d59",
        "storage_key": "property/6737460151192636/019e1de1-f13d-77a9-bc2d-1a26a6889d59.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thevault1905.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1686187249674786796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-vault-1905-sports-grill",
      "poi_latitude": "35.4359243",
      "poi_longitude": "-94.3531996",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-262-2468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ564eelO1y4cR7JeoqV6KZhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6e3935ce-874c-4033-ba7f-c48649f53acd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Downtown Diner",
      "poi_type": "Restaurants",
      "poi_address": "520 Main St, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-882e-704b-aaac-358bf0ed0e7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-882e-704b-aaac-358bf0ed0e7d",
        "storage_key": "property/6737460151192636/019e1de3-882e-704b-aaac-358bf0ed0e7d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/DownTown-Diner-1572557169670259/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4476048929723106788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-diner",
      "poi_latitude": "35.435416",
      "poi_longitude": "-94.3540782",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-689-5211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40df-775e-8cf7-4e278985775a",
        "storage_key": "property/6737460151192636/019e1de2-40df-775e-8cf7-4e278985775a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsyXkqle0y4cR5MVpVckeHj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_1936e4ef-ce7a-445c-aed2-1b50d86b3c8f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "The Hive",
      "poi_type": "Restaurants",
      "poi_address": "719 Main St, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-89bf-7658-b471-27e2ccce2a17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-89bf-7658-b471-27e2ccce2a17",
        "storage_key": "property/6737460151192636/019e1de3-89bf-7658-b471-27e2ccce2a17.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://facebook.com/thehivecollectivevb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2399964372246625120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hive",
      "poi_latitude": "35.4366628",
      "poi_longitude": "-94.3529455",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 858-382-9499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-cb12-77ce-a1cd-13b8ee0abe3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de3-cb12-77ce-a1cd-13b8ee0abe3f",
        "storage_key": "property/6737460151192636/019e1de3-cb12-77ce-a1cd-13b8ee0abe3f.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ484bLOm1y4cRYHtaieFiTiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_fee22a50-951b-49cf-b055-f9ce227121c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Lee Creek Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1931 Rena Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-8d0f-77aa-b3dc-d300cb831304.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-8d0f-77aa-b3dc-d300cb831304",
        "storage_key": "property/6737460151192636/019e1de3-8d0f-77aa-b3dc-d300cb831304.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/1931-Lee-Creek-Market-595358763917497/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16967666026131922037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lee-creek-market",
      "poi_latitude": "35.4614237",
      "poi_longitude": "-94.3929501",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-474-0844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-cb3e-732b-9647-bbcb5b5022ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de3-cb3e-732b-9647-bbcb5b5022ef",
        "storage_key": "property/6737460151192636/019e1de3-cb3e-732b-9647-bbcb5b5022ef.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJNdWTSDS1y4cRdZwOK1pCees",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_5a4f3de0-ba68-43b9-8520-6d7c69d1241e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2214 Fayetteville Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "Department store selling a wide range of items, including electronics, furniture, clothing, and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-8f9e-7371-957d-8880d53ced45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-8f9e-7371-957d-8880d53ced45",
        "storage_key": "property/6737460151192636/019e1de3-8f9e-7371-957d-8880d53ced45.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/16-van-buren-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10164808036427536004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.4693645",
      "poi_longitude": "-94.3535989",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-474-2314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4091-71aa-a3a8-866624963a5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4091-71aa-a3a8-866624963a5d",
        "storage_key": "property/6737460151192636/019e1de2-4091-71aa-a3a8-866624963a5d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIc-Q9561y4cRhJZMvQ2nEI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_3a1ae809-222c-4d6d-a7ec-baba51361f7f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2309 Fayetteville Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-90b7-709a-8c62-27e8b6362870.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-90b7-709a-8c62-27e8b6362870",
        "storage_key": "property/6737460151192636/019e1de3-90b7-709a-8c62-27e8b6362870.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ar/van-buren/2309-fayetteville-rd/f288",
      "poi_directions_map_url": "https://maps.google.com/?cid=16642058414075589384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.471936",
      "poi_longitude": "-94.356992",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-41b5-72ce-9bbd-149704cce0a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-41b5-72ce-9bbd-149704cce0a5",
        "storage_key": "property/6737460151192636/019e1de2-41b5-72ce-9bbd-149704cce0a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZ1CBHa1y4cRCLNGRvR39OY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_93cf62a9-63c7-48be-a59b-d38695c47edb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Harps Food Stores",
      "poi_type": "Shopping & Retail",
      "poi_address": "North Hills Plaza Shopping Center, 601 Pointer Trail, Van Buren, AR 72956, USA",
      "poi_short_description": "Grocery chain for produce, meat, baked goods, and a deli.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-914d-75ac-bfab-a20ea9ccaeec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-914d-75ac-bfab-a20ea9ccaeec",
        "storage_key": "property/6737460151192636/019e1de3-914d-75ac-bfab-a20ea9ccaeec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.harpsfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7129474276799594071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harps-food-stores",
      "poi_latitude": "35.4595844",
      "poi_longitude": "-94.3542276",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-471-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-41b5-72ce-9bbd-149704cce0a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-41b5-72ce-9bbd-149704cce0a5",
        "storage_key": "property/6737460151192636/019e1de2-41b5-72ce-9bbd-149704cce0a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJU6CyAW4y4cRV77sxxT78GI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_037a2a88-cdcd-4731-9a41-aa2133ce4b0d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Price Cutter Food Warehouse 352",
      "poi_type": "Shopping & Retail",
      "poi_address": "120 Cloverleaf Plaza, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5534045564919889807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "price-cutter-food-warehouse-352",
      "poi_latitude": "35.4417201",
      "poi_longitude": "-94.3265883",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-cb3e-732b-9647-bbcb5b5022ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de3-cb3e-732b-9647-bbcb5b5022ef",
        "storage_key": "property/6737460151192636/019e1de3-cb3e-732b-9647-bbcb5b5022ef.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJtTtWVjK0y4cRjz_g4x7hzEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_46b83f9f-ec40-454d-adfa-843097b332c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "1311 Pointer Trail, Van Buren, AR 72956, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-90cc-71f1-9d74-fd66bea1c1b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-90cc-71f1-9d74-fd66bea1c1b1",
        "storage_key": "property/6737460151192636/019e1de3-90cc-71f1-9d74-fd66bea1c1b1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ar/van-buren/3342",
      "poi_directions_map_url": "https://maps.google.com/?cid=13597589141053802386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "35.4590809",
      "poi_longitude": "-94.3443441",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-208-6303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4091-71aa-a3a8-866624963a5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4091-71aa-a3a8-866624963a5d",
        "storage_key": "property/6737460151192636/019e1de2-4091-71aa-a3a8-866624963a5d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJD6R1fQ61y4cRkoc42kdXtLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_fdd14e6b-5d3f-4fdd-a10d-86f1b2606a28",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "2308 Fayetteville Rd #400, Van Buren, AR 72956, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-9129-70bc-a767-744ce6d1a050.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-9129-70bc-a767-744ce6d1a050",
        "storage_key": "property/6737460151192636/019e1de3-9129-70bc-a767-744ce6d1a050.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/ar/van-buren/2308-fayetteville-road-suite-400?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6689294619860386378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "35.471215",
      "poi_longitude": "-94.3546434",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-279-1150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4091-71aa-a3a8-866624963a5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4091-71aa-a3a8-866624963a5d",
        "storage_key": "property/6737460151192636/019e1de2-4091-71aa-a3a8-866624963a5d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzaNggJ61y4cRSsK17gMm1Vw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_e17bac02-a812-4a1a-befc-def3609732b0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "S & S Super Stop",
      "poi_type": "Shopping & Retail",
      "poi_address": "2208 Alma Hwy, Van Buren, AR 72956, USA",
      "poi_short_description": "Convenience store offering gas, coffee, and check cashing services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-93ef-73be-9729-4e714a01ff03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-93ef-73be-9729-4e714a01ff03",
        "storage_key": "property/6737460151192636/019e1de3-93ef-73be-9729-4e714a01ff03.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8933420450031831580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "s--s-super-stop",
      "poi_latitude": "35.43709339999999",
      "poi_longitude": "-94.3353616",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-474-8120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-cb3e-732b-9647-bbcb5b5022ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de3-cb3e-732b-9647-bbcb5b5022ef",
        "storage_key": "property/6737460151192636/019e1de3-cb3e-732b-9647-bbcb5b5022ef.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJE1SvJTa0y4cRHIpbaZHi-Xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_067d6050-47a2-4cf8-9ef2-c1f3e73900fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Tienda El Atoron",
      "poi_type": "Shopping & Retail",
      "poi_address": "2519 Alma Hwy, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-95fa-7549-baab-54627ce9c61c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-95fa-7549-baab-54627ce9c61c",
        "storage_key": "property/6737460151192636/019e1de3-95fa-7549-baab-54627ce9c61c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8455736250000035863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tienda-el-atoron",
      "poi_latitude": "35.4398917",
      "poi_longitude": "-94.3321597",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-471-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-41b5-72ce-9bbd-149704cce0a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-41b5-72ce-9bbd-149704cce0a5",
        "storage_key": "property/6737460151192636/019e1de2-41b5-72ce-9bbd-149704cce0a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzO5ETS0y4cRF1Clp1HPWHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4bcf6fdf-118e-4730-add5-ac38c8e88e5b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Rena Elementary School",
      "poi_type": "Education",
      "poi_address": "720 Rena Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.vbsd.us/schools/rena-elementary-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=8362742517748434807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rena-elementary-school",
      "poi_latitude": "35.4678249",
      "poi_longitude": "-94.3731816",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 479-471-3190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4157-74f8-9fd7-1e9e8967cbf2",
        "storage_key": "property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxWuJmGu1y4cRd4dzHgNuDnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3011dfbb-13e3-41a1-add8-2aef0f91cf7c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Izard",
      "poi_type": "Education",
      "poi_address": "501 N 24th St, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://vbsd.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17689845052141514444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "izard",
      "poi_latitude": "35.4424829",
      "poi_longitude": "-94.3341179",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-471-3150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4157-74f8-9fd7-1e9e8967cbf2",
        "storage_key": "property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ32gRAzW0y4cRzK6YoFn0fvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6d6c7a98-d311-4cca-bc59-2ee34e428748",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Central Elementary School",
      "poi_type": "Education",
      "poi_address": "913 N 24th St, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://vbsd.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8993064417065079573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-elementary-school",
      "poi_latitude": "35.44681000000001",
      "poi_longitude": "-94.3348271",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-474-7059",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4157-74f8-9fd7-1e9e8967cbf2",
        "storage_key": "property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpTeD8sq1y4cRFZNepXDIzXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a41f74af-ac64-41ad-a59b-e00a4b17ee07",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "King Elementary School",
      "poi_type": "Education",
      "poi_address": "401 N 19th Cir, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.vbsd.us/schools/king-elementary-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=11636537753774801035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-elementary-school",
      "poi_latitude": "35.4405164",
      "poi_longitude": "-94.3388487",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-474-2661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4157-74f8-9fd7-1e9e8967cbf2",
        "storage_key": "property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqwRupEu0y4cRi0ArHW9JfaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2ca8d9fb-48b3-4341-80ec-c74dbf56771d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Butterfield Trail Middle School",
      "poi_type": "Education",
      "poi_address": "310 N 11th St, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-9449-7783-8f95-874febeb0e44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-9449-7783-8f95-874febeb0e44",
        "storage_key": "property/6737460151192636/019e1de3-9449-7783-8f95-874febeb0e44.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.vbsd.us/schools/butterfield-trail-middle-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=14434782543094406584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "butterfield-trail-middle-school",
      "poi_latitude": "35.4396359",
      "poi_longitude": "-94.3472633",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-474-6838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4157-74f8-9fd7-1e9e8967cbf2",
        "storage_key": "property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY3PKplK0y4cRuN0mgz6mUsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e043811b-66c8-4835-8f9d-6496f300daf6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Van Buren High School",
      "poi_type": "Education",
      "poi_address": "Pointer Trail, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-9b07-74dd-9ee8-d99ce587c873.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-9b07-74dd-9ee8-d99ce587c873",
        "storage_key": "property/6737460151192636/019e1de3-9b07-74dd-9ee8-d99ce587c873.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "http://www.vbsd.us/schools/van-buren-high-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=12050173620345074576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "van-buren-high-school",
      "poi_latitude": "35.459183",
      "poi_longitude": "-94.3371879",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-474-6821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4157-74f8-9fd7-1e9e8967cbf2",
        "storage_key": "property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh65_wri1y4cRkHNzKhDROqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ad394447-158b-43bf-86df-d7b31e62fe79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Van Buren Freshman Academy on Coleman Campus",
      "poi_type": "Education",
      "poi_address": "821 Pointer Trail, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-99fc-72f8-965b-9110147a021d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-99fc-72f8-965b-9110147a021d",
        "storage_key": "property/6737460151192636/019e1de3-99fc-72f8-965b-9110147a021d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.vbsd.us/schools/freshman-academy",
      "poi_directions_map_url": "https://maps.google.com/?cid=17687557052607185473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "van-buren-freshman-academy-on-coleman-campus",
      "poi_latitude": "35.4597551",
      "poi_longitude": "-94.3505845",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-471-3160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4157-74f8-9fd7-1e9e8967cbf2",
        "storage_key": "property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8X26CqS1y4cRQUIbOW3TdvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_70297847-294c-4c76-aa5d-e002df598797",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Northridge Middle School",
      "poi_type": "Education",
      "poi_address": "120 Northridge Dr, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-9a81-70a8-8ddb-f6f2baaa9817.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-9a81-70a8-8ddb-f6f2baaa9817",
        "storage_key": "property/6737460151192636/019e1de3-9a81-70a8-8ddb-f6f2baaa9817.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.vbsd.us/schools/northridge-middle-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=14278916808592917066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northridge-middle-school",
      "poi_latitude": "35.4768435",
      "poi_longitude": "-94.3593923",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-471-3126",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4157-74f8-9fd7-1e9e8967cbf2",
        "storage_key": "property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqVDr8ne1y4cRSgKJOS_nKMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ccc984ab-b0be-4b2e-9e8d-58ce46e2555b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Parkview Elementary School",
      "poi_type": "Education",
      "poi_address": "619 Parkview St, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.vbsd.us/schools/parkview-elementary-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=11187429658054660151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkview-elementary-school",
      "poi_latitude": "35.4499875",
      "poi_longitude": "-94.3537138",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-474-8730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4157-74f8-9fd7-1e9e8967cbf2",
        "storage_key": "property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFVoGcam1y4cRN5AEHgC8QZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_77021c28-ead8-4a76-abc8-9f1c349212ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Arts On Main",
      "poi_type": "Entertainment",
      "poi_address": "415 Main St, Van Buren, AR 72956, USA",
      "poi_short_description": "Boutique providing pottery classes along with other art and cooking courses.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-9a8a-75b5-b8fe-1709fc3eb05e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-9a8a-75b5-b8fe-1709fc3eb05e",
        "storage_key": "property/6737460151192636/019e1de3-9a8a-75b5-b8fe-1709fc3eb05e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://artsonmainvb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=276694452681777200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arts-on-main",
      "poi_latitude": "35.4350963",
      "poi_longitude": "-94.3550657",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-474-7767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhSsIrVe0y4cRMCBrgyME1wM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "custom_820a62f7-71d2-4164-86bb-1be945bd9f7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "King Opera House",
      "poi_type": "Entertainment",
      "poi_address": "427 Main St, Van Buren, AR 72956, USA",
      "poi_short_description": "Event venue for comedy shows and more that recommends getting tickets in advance.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-9e2f-703e-8909-788c7c01a4a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-9e2f-703e-8909-788c7c01a4a3",
        "storage_key": "property/6737460151192636/019e1de3-9e2f-703e-8909-788c7c01a4a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kingoperahouse.ludus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3520583098958968959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-opera-house",
      "poi_latitude": "35.435275",
      "poi_longitude": "-94.3550219",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-474-7767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbz75s1e0y4cRf3ix96yf2zA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_46f514a8-a0ee-4f6b-beae-9a18d36ebeb5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Drennen Scott House",
      "poi_type": "Entertainment",
      "poi_address": "324 N 3rd St, Van Buren, AR 72956, USA",
      "poi_short_description": "Landmark home built by one the town's first settler's in 1836, with antiques & period relics.",
      "poi_long_description": "Landmark home built by one the town's first settler's in 1836, with antiques & period relics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-9e17-702d-a3e9-437d1b1f9969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-9e17-702d-a3e9-437d1b1f9969",
        "storage_key": "property/6737460151192636/019e1de3-9e17-702d-a3e9-437d1b1f9969.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=100065037011509&mibextid=ZbWKwL",
      "poi_directions_map_url": "https://maps.google.com/?cid=16820112867083933916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "drennen-scott-house",
      "poi_latitude": "35.4359529",
      "poi_longitude": "-94.3593353",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-262-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGbTB7_i0y4cR3NiDLIkLbek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    },
    {
      "id": "custom_b2c0e669-d896-4174-929c-4eea7c8eb697",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Fort Smith National Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "301 Parker Ave, Fort Smith, AR 72901, USA",
      "poi_short_description": "Preserved 19th-century fortress complex chronicling Indian history & law & order in the Old West.",
      "poi_long_description": "Preserved 19th-century fortress complex chronicling Indian history & law & order in the Old West.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-9f40-7499-9234-512d87d24724.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-9f40-7499-9234-512d87d24724",
        "storage_key": "property/6737460151192636/019e1de3-9f40-7499-9234-512d87d24724.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nps.gov/fosm/index.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=1629265599908343225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-smith-national-historic-site",
      "poi_latitude": "35.388139",
      "poi_longitude": "-94.4299163",
      "poi_miles_from_property": "20.7",
      "poi_walking_minutes": "7 hours 39 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 479-783-3961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQbqdp4VMyocRue1MT25QnBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_083a1356-18da-49bb-a890-cbf288aed59f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Fort Smith Museum of History",
      "poi_type": "Entertainment",
      "poi_address": "320 Rogers Ave, Fort Smith, AR 72901, USA",
      "poi_short_description": "Warehouse of artifacts depicting local development along with a 1920s-era soda fountain & gift shop.",
      "poi_long_description": "Warehouse of artifacts depicting local development along with a 1920s-era soda fountain & gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-a41f-76da-a44d-b5a0d4275d74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-a41f-76da-a44d-b5a0d4275d74",
        "storage_key": "property/6737460151192636/019e1de3-a41f-76da-a44d-b5a0d4275d74.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fortsmithmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6478871586896614412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-smith-museum-of-history",
      "poi_latitude": "35.387614",
      "poi_longitude": "-94.42833",
      "poi_miles_from_property": "20.6",
      "poi_walking_minutes": "7 hours 37 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 479-783-7841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40d2-751f-80e4-662e29030ed0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40d2-751f-80e4-662e29030ed0",
        "storage_key": "property/6737460151192636/019e1de2-40d2-751f-80e4-662e29030ed0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRVMNIVMyocRDBRYumGT6Vk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_43b4067f-dbe4-4cfb-b1ca-a7a3a14ecebc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Fort Smith Trolley Museum",
      "poi_type": "Entertainment",
      "poi_address": "100 S 4th St, Fort Smith, AR 72901, USA",
      "poi_short_description": "Outdoor museum featuring historic streetcars & a restored trolley running on a 3/4-mile track.",
      "poi_long_description": "Outdoor museum featuring historic streetcars & a restored trolley running on a 3/4-mile track.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-a27a-701c-8aa9-280704e6fa24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-a27a-701c-8aa9-280704e6fa24",
        "storage_key": "property/6737460151192636/019e1de3-a27a-701c-8aa9-280704e6fa24.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.fstrolley.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17701454797053163614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-smith-trolley-museum",
      "poi_latitude": "35.3855939",
      "poi_longitude": "-94.4306921",
      "poi_miles_from_property": "20.8",
      "poi_walking_minutes": "7 hours 42 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 479-783-0205",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40d2-751f-80e4-662e29030ed0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40d2-751f-80e4-662e29030ed0",
        "storage_key": "property/6737460151192636/019e1de2-40d2-751f-80e4-662e29030ed0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs-1FV4VMyocRXvj8AVozqPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_375e21d5-aa48-42df-969d-74e9d56db1c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Fort Smith Regional Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "1601 Rogers Ave, Fort Smith, AR 72901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-a78f-71ee-80f1-d520bc5c45b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-a78f-71ee-80f1-d520bc5c45b9",
        "storage_key": "property/6737460151192636/019e1de3-a78f-71ee-80f1-d520bc5c45b9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://fsram.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13589683065533977227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-smith-regional-art-museum",
      "poi_latitude": "35.3814597",
      "poi_longitude": "-94.4154387",
      "poi_miles_from_property": "19.8",
      "poi_walking_minutes": "7 hours 18 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-784-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-40d2-751f-80e4-662e29030ed0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-40d2-751f-80e4-662e29030ed0",
        "storage_key": "property/6737460151192636/019e1de2-40d2-751f-80e4-662e29030ed0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQSTbaplMyocRi1JLM79AmLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_2cfd2d88-52f7-4bb8-aa85-a5d0ac325cb0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Baptist Health-Van Buren",
      "poi_type": "Health and Wellness",
      "poi_address": "211 Crawford Memorial Dr, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-0846-77ec-b0df-e5085975e5be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de2-0846-77ec-b0df-e5085975e5be",
        "storage_key": "property/6737460151192636/019e1de2-0846-77ec-b0df-e5085975e5be.webp",
        "width": 928,
        "height": 522
      },
      "poi_business_url": "https://www.baptist-health.com/find-care/location/baptist-health-van-buren/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12519616051071932641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-van-buren",
      "poi_latitude": "35.4355303",
      "poi_longitude": "-94.3389192",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-474-3401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-41af-774a-accb-3a7dc6c97abc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-41af-774a-accb-3a7dc6c97abc",
        "storage_key": "property/6737460151192636/019e1de2-41af-774a-accb-3a7dc6c97abc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Zn8IutMyocR4dhreHecvq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a853b271-efd4-48d7-a85d-90e31ba4b49d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Baptist Health Urgent Care - Van Buren",
      "poi_type": "Health and Wellness",
      "poi_address": "1902 Fayetteville Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-a6bc-7052-8188-a2bb006abcd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-a6bc-7052-8188-a2bb006abcd0",
        "storage_key": "property/6737460151192636/019e1de3-a6bc-7052-8188-a2bb006abcd0.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.urgentteam.com/locations/baptist-health-urgent-care-van-buren-ar/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7801299594214810886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-urgent-care---van-buren",
      "poi_latitude": "35.4642881",
      "poi_longitude": "-94.3558219",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 479-208-5047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1eNJom1y4cRBqWS26XIQ2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_40596482-7814-4332-9d2a-3797407dbd80",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2015 Fayetteville Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-8d52-70bf-af74-24ef908e2282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-8d52-70bf-af74-24ef908e2282",
        "storage_key": "property/6737460151192636/019e1de3-8d52-70bf-af74-24ef908e2282.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/van-buren-ar-pharmacies/2015-fayetteville-road-van-buren-ar-72956/storeid=10255?WT.mc_id=LS_GOOGLE_RX_10255",
      "poi_directions_map_url": "https://maps.google.com/?cid=6923561930028126768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.46662329999999",
      "poi_longitude": "-94.3569044",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 479-471-1608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-cb10-7279-b482-ab5f908d250e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de3-cb10-7279-b482-ab5f908d250e",
        "storage_key": "property/6737460151192636/019e1de3-cb10-7279-b482-ab5f908d250e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQVt_4J-1y4cRMJK-i-RuFWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_0aa4f23e-9266-4893-ab08-93fc6e6a9b3d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1601 Fayetteville Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-a661-758e-ae78-35cc5c4644c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-a661-758e-ae78-35cc5c4644c5",
        "storage_key": "property/6737460151192636/019e1de3-a661-758e-ae78-35cc5c4644c5.webp",
        "width": 611,
        "height": 456
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1601+fayetteville+rd-van+buren-ar-72956/id=7235",
      "poi_directions_map_url": "https://maps.google.com/?cid=5983646524019421680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.4594094",
      "poi_longitude": "-94.3572445",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-474-8859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM7O1-gm1y4cR8LGtlc8uClM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_d58cb3c6-522e-4c2c-b894-df167136b18e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2214 Fayetteville Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-a69d-756d-a21a-4e0c3a331907.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-a69d-756d-a21a-4e0c3a331907",
        "storage_key": "property/6737460151192636/019e1de3-a69d-756d-a21a-4e0c3a331907.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/16-van-buren-ar/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11931079993439165136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "35.4693645",
      "poi_longitude": "-94.3535989",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-474-5051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-cb10-7279-b482-ab5f908d250e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de3-cb10-7279-b482-ab5f908d250e",
        "storage_key": "property/6737460151192636/019e1de3-cb10-7279-b482-ab5f908d250e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIc-Q9561y4cR0Bq2Wwq2k6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_1d44548c-8141-4637-b31c-fd8538df9e01",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Van Buren Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "106 W Pointer Trail, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-ac7b-7792-8872-12772f79232f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-ac7b-7792-8872-12772f79232f",
        "storage_key": "property/6737460151192636/019e1de3-ac7b-7792-8872-12772f79232f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7414996545415449455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "van-buren-athletic-club",
      "poi_latitude": "35.4594982",
      "poi_longitude": "-94.3591227",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-474-1498",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVVYKQy1y4cRb4s8XBJc52Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0b1fe1d0-12a3-4b2c-a817-0afa7b27cc9c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1514 Fayetteville Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-a923-76cf-8b77-da0076c7d7eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-a923-76cf-8b77-da0076c7d7eb",
        "storage_key": "property/6737460151192636/019e1de3-a923-76cf-8b77-da0076c7d7eb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.anytimefitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7248815862679051163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "35.457356",
      "poi_longitude": "-94.3561381",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-689-5189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWR3GKQi1y4cRm5szCZ_3mGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cfd689a3-9c3f-471f-b793-c38313379a4b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Radiant Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "1612 N 7th St Ste C, Van Buren, AR 72956, USA",
      "poi_short_description": "Spa offering massages such as Swedish, deep tissue, and Thai, plus facials and Pilates sessions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-a9c8-722a-80af-736efa9dbf9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-a9c8-722a-80af-736efa9dbf9d",
        "storage_key": "property/6737460151192636/019e1de3-a9c8-722a-80af-736efa9dbf9d.webp",
        "width": 564,
        "height": 564
      },
      "poi_business_url": "http://radiantwellnessvb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2216414313750166937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "radiant-wellness",
      "poi_latitude": "35.4603756",
      "poi_longitude": "-94.3524568",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-279-0106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqaHQy1a0y4cRmX0rRhNJwh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spa"
    },
    {
      "id": "custom_9d3231d9-71a2-4519-ad29-3d0505437729",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Seva Yoga Studios",
      "poi_type": "Health and Wellness",
      "poi_address": "3400 Rogers Ave #136, Fort Smith, AR 72903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-ac38-73fd-92cd-33792840fc9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-ac38-73fd-92cd-33792840fc9f",
        "storage_key": "property/6737460151192636/019e1de3-ac38-73fd-92cd-33792840fc9f.webp",
        "width": 1280,
        "height": 860
      },
      "poi_business_url": "https://www.sevayogastudios.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4341844482416748510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seva-yoga-studios",
      "poi_latitude": "35.371084",
      "poi_longitude": "-94.3938571",
      "poi_miles_from_property": "18.5",
      "poi_walking_minutes": "6 hours 50 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-755-4120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4157-74f8-9fd7-1e9e8967cbf2",
        "storage_key": "property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGwmMQiqzy4cR3qdwfI1UQTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_c9cf1c87-349e-454f-a17c-91f86ce806a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Lee Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2876 Lee Creek Park Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "Quiet park featuring a boat ramp and riverside trails, as well as picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-10d0-724f-813d-81d8b4ab06e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de2-10d0-724f-813d-81d8b4ab06e4",
        "storage_key": "property/6737460151192636/019e1de2-10d0-724f-813d-81d8b4ab06e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vanburencity.org/220/Lee-Creek-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5295812935252270755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lee-creek-park",
      "poi_latitude": "35.435095",
      "poi_longitude": "-94.3611782",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-471-5006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-421d-742e-b867-9b5a7ec02543",
        "storage_key": "property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0pr-x21y4cRo16hYs6Bfkk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ef67a18c-b232-4d5f-adb1-a7a862fa913b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Freedom Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "957 E Main St, Van Buren, AR 72956, USA",
      "poi_short_description": "Downtown city park featuring a splash pad and picnic tables, plus special events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-a066-760f-9f41-5eab7e724a77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-a066-760f-9f41-5eab7e724a77",
        "storage_key": "property/6737460151192636/019e1de3-a066-760f-9f41-5eab7e724a77.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.vanburencity.org/227/Freedom-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5750618496364249435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freedom-park",
      "poi_latitude": "35.4371259",
      "poi_longitude": "-94.3510882",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-471-5006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-421d-742e-b867-9b5a7ec02543",
        "storage_key": "property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WYlSlG0y4cRWwGV6g1Nzk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_29dd7eed-27c4-46ba-b584-8e3825eda6f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Van Buren Municipal Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1336 City Park Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13889055548463176519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "van-buren-municipal-park",
      "poi_latitude": "35.4492188",
      "poi_longitude": "-94.3439897",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-421d-742e-b867-9b5a7ec02543",
        "storage_key": "property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____K7K1y4cRR9vQF2_Wv8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_540d6812-3bd7-4408-9314-202f8d43d966",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Meyer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "191 Lee Creek Park Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11515743310682596593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meyer-park",
      "poi_latitude": "35.4336232",
      "poi_longitude": "-94.3594034",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-421d-742e-b867-9b5a7ec02543",
        "storage_key": "property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqzvm0y4cR8STRLYcj0J8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_af60bf84-738d-4a20-a70e-1b444864406e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Field of Dreams Sports Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Toothaker Dr, Van Buren, AR 72956, USA",
      "poi_short_description": "Ball facility and fireworks venue featuring multiple baseball diamonds and concessions stands, plus a creek.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-b013-712e-a43c-a33e021fac8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-b013-712e-a43c-a33e021fac8d",
        "storage_key": "property/6737460151192636/019e1de3-b013-712e-a43c-a33e021fac8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vanburencity.org/216/Field-of-Dreams-Sports-Complex",
      "poi_directions_map_url": "https://maps.google.com/?cid=11886656815709463084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "field-of-dreams-sports-complex",
      "poi_latitude": "35.4612877",
      "poi_longitude": "-94.3864896",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-474-1541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtR4JJje1y4cRLKJWS2Xj9aQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_495e0239-c819-40bf-bd34-6cc5788520e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Van Zandt Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Crape Myrtle Rd &, N Park St, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12647464025625208019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "van-zandt-park",
      "poi_latitude": "35.4499642",
      "poi_longitude": "-94.3265971",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-421d-742e-b867-9b5a7ec02543",
        "storage_key": "property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXSwJRwC1y4cR0yTsrIXRhK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cba8d7e8-fa87-47bf-b396-05a2aee69613",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Lake Louemma Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-ba2a-71b8-818f-c342895ac244.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-ba2a-71b8-818f-c342895ac244",
        "storage_key": "property/6737460151192636/019e1de3-ba2a-71b8-818f-c342895ac244.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14921755084124478941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-louemma-park",
      "poi_latitude": "35.4647169",
      "poi_longitude": "-94.3597245",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-421d-742e-b867-9b5a7ec02543",
        "storage_key": "property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____Lwu1y4cR3V2erjC5FM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8b98b40b-db40-4a05-9fa6-791a3086c4f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Ben Geren Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7200 Zero St, Fort Smith, AR 72903, USA",
      "poi_short_description": "Wide-ranging park with a disc golf course, a mountain biking trail, a playground & other features.",
      "poi_long_description": "Wide-ranging park with a disc golf course, a mountain biking trail, a playground & other features.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-b204-72bd-8c72-c4cf2432cd7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-b204-72bd-8c72-c4cf2432cd7a",
        "storage_key": "property/6737460151192636/019e1de3-b204-72bd-8c72-c4cf2432cd7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sebastiancountyar.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9644261936122966883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ben-geren-regional-park",
      "poi_latitude": "35.3222298",
      "poi_longitude": "-94.349383",
      "poi_miles_from_property": "15.9",
      "poi_walking_minutes": "5 hours 50 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 479-646-2444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-421d-742e-b867-9b5a7ec02543",
        "storage_key": "property/6737460151192636/019e1de2-421d-742e-b867-9b5a7ec02543.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw3dp2nyyy4cRYzNuJyJN14U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ff26bb39-831d-4946-85b2-25259fa0559a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Kay Rodgers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4400 Midland Blvd, Fort Smith, AR 72904, USA",
      "poi_short_description": "Site of various of events, including the state fair & rodeos, with an expo center, stadium & arena.",
      "poi_long_description": "Site of various of events, including the state fair & rodeos, with an expo center, stadium & arena.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-b8bc-7173-909b-d5ac0391619e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-b8bc-7173-909b-d5ac0391619e",
        "storage_key": "property/6737460151192636/019e1de3-b8bc-7173-909b-d5ac0391619e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kayrodgerspark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7019200375948960841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kay-rodgers-park",
      "poi_latitude": "35.4192281",
      "poi_longitude": "-94.3793193",
      "poi_miles_from_property": "21.5",
      "poi_walking_minutes": "7 hours 54 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-783-6176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo8Stur-0y4cRSeS5d401aWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_55dcf61b-7153-434a-ad73-c8be1d6c9230",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Jefferson Lines",
      "poi_type": "Transportation & Transit",
      "poi_address": "2321 Industrial Park Rd, Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jeffersonlines.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=59586427627501320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-lines",
      "poi_latitude": "35.4222979",
      "poi_longitude": "-94.334371",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 858-800-8898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcwaLDK61y4cRCPcrTIqx0wA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_7ba8f0a4-22b8-44df-b3dc-c8f1758ab1d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Van Buren Visitors Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "813 Main St, Van Buren, AR 72956, USA",
      "poi_short_description": "Information center with train rides, displays of memorabilia and helpful staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-9d53-71bd-b8f1-03b07f133ec1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-9d53-71bd-b8f1-03b07f133ec1",
        "storage_key": "property/6737460151192636/019e1de3-9d53-71bd-b8f1-03b07f133ec1.webp",
        "width": 960,
        "height": 602
      },
      "poi_business_url": "http://www.vanburen.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2693615038755721248&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "van-buren-visitors-center",
      "poi_latitude": "35.4370498",
      "poi_longitude": "-94.3520938",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-332-5889",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYYdzuFa0y4cRIFCvOpukYSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_information_center"
    },
    {
      "id": "custom_7718cc1f-2fbd-4f50-b480-cf362ca1dc41",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Arkansas Welcome Center at Van Buren/Fort Smith",
      "poi_type": "Transportation & Transit",
      "poi_address": "2915 I-40, Van Buren, AR 72956, USA",
      "poi_short_description": "Tourist information center supplying literature about Arkansas, plus restrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-b9e4-77c8-95ee-fdbaf96b61c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-b9e4-77c8-95ee-fdbaf96b61c0",
        "storage_key": "property/6737460151192636/019e1de3-b9e4-77c8-95ee-fdbaf96b61c0.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.arkansas.com/arkansas-welcome-centers",
      "poi_directions_map_url": "https://maps.google.com/?cid=5605451273511165430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-welcome-center-at-van-burenfort-smith",
      "poi_latitude": "35.4587224",
      "poi_longitude": "-94.3986434",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-474-9512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNZjJWMtKyocR9t1k-zuQyk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_information_center"
    },
    {
      "id": "custom_5ed3254a-6833-4b4d-a151-83b507176948",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Downtown Bus Tranfer Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "701 B St S, Fort Smith, AR 72901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-b664-742b-ac26-f27bec43aa9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-b664-742b-ac26-f27bec43aa9c",
        "storage_key": "property/6737460151192636/019e1de3-b664-742b-ac26-f27bec43aa9c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.fortsmithar.gov/government/departments/transit",
      "poi_directions_map_url": "https://maps.google.com/?cid=16393041438291093817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-bus-tranfer-station",
      "poi_latitude": "35.3817609",
      "poi_longitude": "-94.426695",
      "poi_miles_from_property": "20.4",
      "poi_walking_minutes": "7 hours 32 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 479-783-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJzP2kJFMyocROWmZhVXIf-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_15861195-3e57-4fa8-95b4-c1242fa32958",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Van Buren/ Ft Smith Bus Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "Van Buren, AR 72956, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17465996273190692768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "van-buren-ft-smith-bus-depot",
      "poi_latitude": "35.422301",
      "poi_longitude": "-94.334419",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3x1qYRW0y4cRoOfTVxKvY_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_0778bc56-175c-41bd-a7f2-b3b0efaaf1a6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Fort Smith Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6700 McKennon Blvd Ste 200, Fort Smith, AR 72903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-bcab-74ca-9419-8d1cc7c202d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-bcab-74ca-9419-8d1cc7c202d5",
        "storage_key": "property/6737460151192636/019e1de3-bcab-74ca-9419-8d1cc7c202d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyfsm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5330905758402585595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-smith-regional-airport",
      "poi_latitude": "35.3375476",
      "poi_longitude": "-94.3656122",
      "poi_miles_from_property": "17.4",
      "poi_walking_minutes": "6 hours 24 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 479-452-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-cb12-77ce-a1cd-16d9c8c2d153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de3-cb12-77ce-a1cd-16d9c8c2d153",
        "storage_key": "property/6737460151192636/019e1de3-cb12-77ce-a1cd-16d9c8c2d153.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmwPq8PGyy4cR-6Or_Iou-0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_280d061a-caef-4357-bfeb-30af897ca926",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "City-Fort Smith Transportation Department",
      "poi_type": "Transportation & Transit",
      "poi_address": "6821 Jenny Lind Rd, Fort Smith, AR 72908, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.fortsmithar.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14067221128792429283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-fort-smith-transportation-department",
      "poi_latitude": "35.3175939",
      "poi_longitude": "-94.408678",
      "poi_miles_from_property": "19.7",
      "poi_walking_minutes": "7 hours 14 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 479-783-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-cb40-7599-a36b-1edaeacb55dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de3-cb40-7599-a36b-1edaeacb55dd",
        "storage_key": "property/6737460151192636/019e1de3-cb40-7599-a36b-1edaeacb55dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhcWRhVxNyocR49KK1hXPOMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_a70d91d8-4811-446c-b916-3df459189ab0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Mercy Hospital Fort Smith",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7301 Rogers Ave, Fort Smith, AR 72903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-a46a-7610-b7df-476332401b6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-a46a-7610-b7df-476332401b6c",
        "storage_key": "property/6737460151192636/019e1de3-a46a-7610-b7df-476332401b6c.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-fort-smith?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=Central&utm_content=website&y_source=1_MTI5OTU1OTgtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=15260475051626619680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-hospital-fort-smith",
      "poi_latitude": "35.3555724",
      "poi_longitude": "-94.3536152",
      "poi_miles_from_property": "15.9",
      "poi_walking_minutes": "5 hours 50 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 479-314-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-41af-774a-accb-3a7dc6c97abc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-41af-774a-accb-3a7dc6c97abc",
        "storage_key": "property/6737460151192636/019e1de2-41af-774a-accb-3a7dc6c97abc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_6D9lSyy4cRIGPquzQZyNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_1265f601-4cd5-465a-9ea1-ea2a112eec71",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Baptist Health-Fort Smith",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1001 Towson Ave, Fort Smith, AR 72901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-b909-734f-b3a1-5869ebde8509.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-b909-734f-b3a1-5869ebde8509",
        "storage_key": "property/6737460151192636/019e1de3-b909-734f-b3a1-5869ebde8509.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.baptist-health.com/find-care/location/baptist-health-fort-smith/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18101256003690073140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-fort-smith",
      "poi_latitude": "35.3741136",
      "poi_longitude": "-94.419774",
      "poi_miles_from_property": "20.1",
      "poi_walking_minutes": "7 hours 25 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 479-441-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-41af-774a-accb-3a7dc6c97abc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-41af-774a-accb-3a7dc6c97abc",
        "storage_key": "property/6737460151192636/019e1de2-41af-774a-accb-3a7dc6c97abc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Zn8IutMyocRNIxaSG6UNPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ad1b41e5-82ff-40a2-ad4f-81c2d717ebb6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "University of Arkansas - Fort Smith",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5210 Grand Ave, Fort Smith, AR 72904, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de1-f01c-749f-a860-a5d1da7e7147.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-f01c-749f-a860-a5d1da7e7147",
        "storage_key": "property/6737460151192636/019e1de1-f01c-749f-a860-a5d1da7e7147.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://uafs.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3773270515557777971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas---fort-smith",
      "poi_latitude": "35.3826091",
      "poi_longitude": "-94.3736471",
      "poi_miles_from_property": "18.4",
      "poi_walking_minutes": "6 hours 48 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-788-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4157-74f8-9fd7-1e9e8967cbf2",
        "storage_key": "property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG2zem2mzy4cRM8JG0YpZXTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_64e5460a-4615-48b6-be0f-fb48f5a93ed7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "ArcBest",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3801 Old Greenwood Rd, Fort Smith, AR 72903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-bf47-7408-8783-9566ad512405.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-bf47-7408-8783-9566ad512405",
        "storage_key": "property/6737460151192636/019e1de3-bf47-7408-8783-9566ad512405.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://arcb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3306000715954223056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arcbest",
      "poi_latitude": "35.3455731",
      "poi_longitude": "-94.39252410000002",
      "poi_miles_from_property": "18.3",
      "poi_walking_minutes": "6 hours 46 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 479-785-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR_bTKdKyy4cR0HejnSJG4S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cd473103-f41b-4ae9-bbe1-abdf0c0e986d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Rheem Air Headquarters and Manufacturing Facility",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4100 S Zero St, Fort Smith, AR 72908, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-bea9-762e-b107-1f343b766ed5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-bea9-762e-b107-1f343b766ed5",
        "storage_key": "property/6737460151192636/019e1de3-bea9-762e-b107-1f343b766ed5.webp",
        "width": 940,
        "height": 1280
      },
      "poi_business_url": "http://rheem.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=319590602836694463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rheem-air-headquarters-and-manufacturing-facility",
      "poi_latitude": "35.3254966",
      "poi_longitude": "-94.3888876",
      "poi_miles_from_property": "18.4",
      "poi_walking_minutes": "6 hours 45 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 479-646-4311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVVeWsy4cRv1Wiw_VpbwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_9fc9603b-fd5b-4a8a-9769-409bd6b5490f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Planters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4020 Planters Rd, Fort Smith, AR 72908, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-c0e0-76df-8c18-0896bd58122f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-c0e0-76df-8c18-0896bd58122f",
        "storage_key": "property/6737460151192636/019e1de3-c0e0-76df-8c18-0896bd58122f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7773860328256580410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planters",
      "poi_latitude": "35.3036477",
      "poi_longitude": "-94.3892347",
      "poi_miles_from_property": "19.4",
      "poi_walking_minutes": "7 hours 8 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 479-648-0138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4-lwslCty4cROis858dM4ms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_d87cf20d-fab4-42c6-8d7d-b11e1330c0fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Gerber Products Co",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4301 Harriet Ave, Fort Smith, AR 72904, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-c2d6-752f-b922-541a8088e8fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-c2d6-752f-b922-541a8088e8fc",
        "storage_key": "property/6737460151192636/019e1de3-c2d6-752f-b922-541a8088e8fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1468943548065795381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gerber-products-co",
      "poi_latitude": "35.4312462",
      "poi_longitude": "-94.381412",
      "poi_miles_from_property": "22",
      "poi_walking_minutes": "8 hours 7 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-782-8671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-f_ucMO0y4cRNU2QyV-8YhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_97f37773-d4d6-4100-8efa-321dedf6b965",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Gerdau Special Steel Fort Smith",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5225 Planters Rd, Fort Smith, AR 72916, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-c1cb-76ed-a32e-236655d2d9f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-c1cb-76ed-a32e-236655d2d9f2",
        "storage_key": "property/6737460151192636/019e1de3-c1cb-76ed-a32e-236655d2d9f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://gsn.gerdau.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3136622106244043808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gerdau-special-steel-fort-smith",
      "poi_latitude": "35.3060103",
      "poi_longitude": "-94.375221",
      "poi_miles_from_property": "18.6",
      "poi_walking_minutes": "6 hours 50 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 479-646-0223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-413f-73ed-96a6-589f3c6bcd7e",
        "storage_key": "property/6737460151192636/019e1de2-413f-73ed-96a6-589f3c6bcd7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUSONMGety4cRIFRQ5S-Fhys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_04dd31e0-fcc0-4d2b-9c8b-6fe9efc468d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "Fort Smith Public Schools Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3205 Jenny Lind Rd, Fort Smith, AR 72901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.fortsmithschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15696113419261357477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-smith-public-schools-service-center",
      "poi_latitude": "35.3508907",
      "poi_longitude": "-94.4115826",
      "poi_miles_from_property": "19.8",
      "poi_walking_minutes": "7 hours 19 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 479-785-2501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de2-4157-74f8-9fd7-1e9e8967cbf2",
        "storage_key": "property/6737460151192636/019e1de2-4157-74f8-9fd7-1e9e8967cbf2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH-ZwrSBNyocRpa1QRf7L09k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_78792689-28a5-446a-8da3-05eb522cd9ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "custom",
      "poi_name": "188th Wing Air National Guard Recruiting",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4850 Leigh Ave, Fort Smith, AR 72903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-c591-701c-8f3f-45b14e9281c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de3-c591-701c-8f3f-45b14e9281c1",
        "storage_key": "property/6737460151192636/019e1de3-c591-701c-8f3f-45b14e9281c1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.188wg.ang.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10976805260008534901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "188th-wing-air-national-guard-recruiting",
      "poi_latitude": "35.3391453",
      "poi_longitude": "-94.3708735",
      "poi_miles_from_property": "17.5",
      "poi_walking_minutes": "6 hours 26 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 479-573-5138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019e1de3-cb40-7599-a36b-1edaeacb55dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de3-cb40-7599-a36b-1edaeacb55dd",
        "storage_key": "property/6737460151192636/019e1de3-cb40-7599-a36b-1edaeacb55dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZTETKfKyy4cRdbNy8zlyVZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_4987e690-dda4-40e0-a52e-4a0f8dfcc1de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_92426775-ae9c-495f-89a0-04ce063c0fff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_ca8bc6a8-c4f8-4233-9d1a-698f120870ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_83db9798-3713-4795-baa0-de72b961c667",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_fc0ffe11-3a7a-43cf-9bef-98c4579375da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_8d24a2fe-32ed-4ac8-bd50-9ff1eb03d57b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "rating": "5",
      "name": "Steven Dutton",
      "text": "I’ve been living at Rena Valley Apartments for six years, and this community just keeps getting better and better! It’s a very clean place with an awesome little pool and a nice dog park. For families living close together, it’s surprisingly quiet and peaceful. I haven’t seen a single bug in the entire six years I’ve been here.\nSafety is excellent too — several law enforcement officers live here, and we even have a police officer on duty that residents can call if needed. That gives everyone extra peace of mind.\nDeborah is an awesome property manager. If you ever have any problems or concerns, you can always reach out to her and she’ll take care of it right away. She’s so easy to talk to and genuinely cares. She’s not just my property manager — she’s become a good friend. I’ve known her for going on five years now, and she does a lot to make this a great place to live.\nRobert, our maintenance guy, is a wonderful person who really knows his stuff. He doesn’t do any shoddy work — everything he does looks so clean and professional. You can tell he takes pride in what he does.\nI was really looking forward to the pool opening today for Memorial Day (the weather is perfect — partly cloudy with a high of 86°F), but I understand it’s delayed because the state of Arkansas requires a phone to be installed outside the pool area. Safety comes first, and I know it’ll be handled well.\nFor the bang for your buck, Rena Valley is the best deal in town. It’s next to a great school, plus school choice makes other options easy if you want them. It’s also super convenient — close to shopping centers, grocery stores, and entertainment. Overall, it’s a great place to be!\nThank you Deborah and Robert for all you do! Highly recommend Rena Valley Apartments.",
      "date": "2026-05-25",
      "title": "false"
    },
    {
      "id": "custom_74157f53-2345-4121-baaf-4937d2602649",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "rating": "5",
      "name": "janine schaub",
      "text": "if you’re looking for a quiet, clean, beautiful, pet friendly, pool ready, awesome management and maintenance place…this is it! Always fun activities going on and everyone’s like a family. I love it here!",
      "date": "2026-04-17",
      "title": "false"
    },
    {
      "id": "custom_800cca18-572a-4d20-8b91-21386d4e2c2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "rating": "5",
      "name": "imbert gloria",
      "text": "Loved the professionalism and the Attention given as well as being friendly upon arriving for my appointment. Mrs Debra Greeted me with a smile and i felt welcomed. Mrs. Debra, went above and beyond To answer Any questions or concerns i had.\n\nI am Very pleased…\nAttentively, Gloria Imbert",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_950b661e-409c-4a79-8c72-ef11b10b51ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "rating": "5",
      "name": "Paige Hopkins",
      "text": "I absolutely love living here! It’s very clean and well maintained, and also very quiet and convenient to town. Deborah is a very attentive manager and always kind and pleasant to speak with. Highly recommend this property!",
      "date": "2026-03-27",
      "title": "false"
    },
    {
      "id": "custom_bd6493d0-6625-4ba6-9adb-a3bdeced5252",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "rating": "5",
      "name": "Jason Brown",
      "text": "An amazing place to live. Debra was extremely helpful and I would strongly recommend living here at Rena Valley.",
      "date": "2026-03-27",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e95-b5b9-763c-aa67-de64b431e85d",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-rena-valley-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636"
    },
    {
      "lead_collector_id": "019a1856-db51-728e-b0b1-24c566e60ff3",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-rena-valley-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636"
    },
    {
      "lead_collector_id": "019d6351-0aac-763a-99dc-a694fa863484",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-van-buren-ar",
      "search_query": "in unit laundry apartments Van Buren AR",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Van Buren, AR",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Rena Valley Apartments. Experience modern living in Van Buren, AR with our exclusive amenities.",
      "page_copy": "At Rena Valley Apartments, we understand the importance of convenience, which is why our properties offer the comfort of in-unit laundry facilities. Located in the beautiful city of Van Buren, AR, our apartments are designed with your lifestyle in mind, providing practical features alongside luxurious amenities. Choose between our spacious one or two-bedroom floor plans and enjoy modern conveniences that make life easy.\n\nBeyond the private comforts of in-unit laundry, Rena Valley Apartments boasts a range of amenities including a sparkling pool and a stylish clubhouse, perfect for community gatherings or solo relaxation. Our location in Crawford County offers a serene environment, perfect for unwinding after a busy day. Come see why Rena Valley Apartments is the premier choice for those seeking both luxury and convenience in Van Buren, AR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and community amenities in autumn.",
        "public_id": "019d0784-4c71-7312-a0bf-756054899ec7",
        "storage_key": "property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Van Buren, AR",
      "seo_description": "Find in-unit laundry apartments in Van Buren, AR at Rena Valley. Enjoy convenience with top-notch amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-crawford-county",
      "search_query": "luxury apartments with pool Crawford County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Crawford County",
      "h2_subtitle": "Enjoy elegant living at Rena Valley Apartments, where luxury meets convenience. Dive into our sparkling pool in the heart of Crawford County.",
      "page_copy": "Rena Valley Apartments offers the epitome of luxury living in Crawford County. Our apartments feature a range of amenities designed to provide an unparalleled lifestyle, including a refreshing pool that serves as the perfect oasis during hot summer days. Whether you're seeking a one or two-bedroom floor plan, our luxurious spaces cater to your every need with style and comfort.\n\nSituated in the serene surroundings of Crawford County, our community provides not only top-notch facilities like a clubhouse and fitness center but also a peaceful living environment. The pool is ideal for both leisurely swims and social gatherings, making it a centerpiece of relaxation and community interaction. Experience the blend of comfort, convenience, and luxury that can only be found at Rena Valley Apartments, your premier destination for elegant living in the area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and community amenities in autumn.",
        "public_id": "019d0784-4c71-7312-a0bf-756054899ec7",
        "storage_key": "property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool Crawford County",
      "seo_description": "Discover luxury apartments with a pool in Crawford County at Rena Valley. Experience top-tier amenities and serene living. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "page_item_url": "apartments-with-air-conditioning-van-buren",
      "search_query": "apartments with air conditioning Van Buren",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Van Buren",
      "h2_subtitle": "Stay cool at Rena Valley Apartments, offering air-conditioned units in Van Buren. Comfort and style in every home.",
      "page_copy": "Experience comfortable living at Rena Valley Apartments in Van Buren, where air conditioning is a standard feature in our welcoming homes. Our one or two-bedroom floor plans provide a cool refuge during the warm Arkansas summers, ensuring you and your family enjoy comfort year-round. Beyond temperature control, our apartments feature elegant fixtures and spacious layouts.\n\nRena Valley Apartments doesn't just deliver comfort but also luxury, with amenities like a refreshing pool and an inviting clubhouse. Located in charming Van Buren, AR, and nestled in Crawford County, our community offers both convenience and relaxation. Whether you're lounging by the pool or enjoying the cool air indoors, Rena Valley sets the benchmark for modern apartment living with all the comforts you'd expect.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and community amenities in autumn.",
        "public_id": "019d0784-4c71-7312-a0bf-756054899ec7",
        "storage_key": "property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning Van Buren",
      "seo_description": "Find air-conditioned apartments in Van Buren at Rena Valley. Enjoy year-round comfort with luxury amenities. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-crawford-county",
      "search_query": "apartments with dishwasher Crawford County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Crawford County",
      "h2_subtitle": "Enjoy hassle-free living at Rena Valley Apartments in Crawford County. Discover modern homes equipped with dishwashers and more.",
      "page_copy": "Rena Valley Apartments in Crawford County is where convenience meets modern living, offering spacious apartments equipped with dishwashers. Enjoy the ease of modern kitchen appliances in our beautifully designed one or two-bedroom units, making cleanup after meals a breeze. Our rooms are thoughtfully designed to complement your lifestyle and provide you with utmost comfort.\n\nIn addition to the convenient in-unit dishwasher, residents can take advantage of various amenities such as a stunning pool and a welcoming clubhouse ideal for socializing. Situated in the calm and scenic environment of Crawford County, Rena Valley Apartments offers the perfect blend of urban convenience and tranquil living. Come experience how these thoughtful amenities enhance everyday living in our vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and community amenities in autumn.",
        "public_id": "019d0784-4c71-7312-a0bf-756054899ec7",
        "storage_key": "property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher Crawford County",
      "seo_description": "Find apartments with a dishwasher in Crawford County at Rena Valley. Enjoy modern amenities and convenient living. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "page_item_url": "family-friendly-apartments-with-playground-van-buren",
      "search_query": "family friendly apartments with playground Van Buren",
      "category": "Amenity",
      "h1_title": "Family-Friendly Apartments in Van Buren",
      "h2_subtitle": "Discover Rena Valley Apartments in Van Buren, where family-friendly living meets fun and safety, complete with a playground.",
      "page_copy": "Welcome to Rena Valley Apartments in Van Buren, a true haven for families seeking a warm and inviting community. Nestled in the heart of Crawford County, our apartments are designed with family life in mind, offering a playground that ensures endless fun and outdoor activity opportunities for children. Choose from our spacious one or two-bedroom floor plans, perfect for growing families.\n\nOur family-friendly environment extends beyond the playground, incorporating various amenities such as a refreshing pool and a clubhouse that are ideal for family gatherings and community events. Rena Valley Apartments are not only safe and secure but also capture the essence of a vibrant community atmosphere. Experience how we’ve crafted a unique living experience where safety, comfort, and family fun go hand in hand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and community amenities in autumn.",
        "public_id": "019d0784-4c71-7312-a0bf-756054899ec7",
        "storage_key": "property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Apartments in Van Buren",
      "seo_description": "Explore family-friendly apartments in Van Buren with a playground at Rena Valley. Perfect for families seeking comfort and fun. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-van-buren-ar",
      "search_query": "one bedroom apartments van buren ar",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Van Buren, AR",
      "h2_subtitle": "Explore stylish one bedroom apartments at Rena Valley in Van Buren, AR. Perfect for singles or couples seeking comfort and convenience.",
      "page_copy": "Discover the perfect blend of style and comfort with our one bedroom apartments at Rena Valley in Van Buren, AR. Ideal for singles or couples, these thoughtfully designed spaces offer modern amenities and a cozy atmosphere. Enjoy efficient layouts that maximize living area, while features like air conditioning and stainless steel appliances add a touch of elegance.\n\nLocated in the heart of Crawford County, Rena Valley Apartments offers more than just a home; it provides a community with a sparkling pool, a welcoming clubhouse, and access to a range of activities. Make yourself at home in Van Buren, where each unit is tailored for convenience and relaxation. Schedule a tour today and experience the ambiance and quality of our one bedroom offerings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and community amenities in autumn.",
        "public_id": "019d0784-4c71-7312-a0bf-756054899ec7",
        "storage_key": "property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Van Buren, AR",
      "seo_description": "Find stylish one bedroom apartments in Van Buren, AR at Rena Valley. Perfect for comfort and convenience. Contact us today for more details!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192636",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-crawford-county",
      "search_query": "two bedroom apartments crawford county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Crawford County",
      "h2_subtitle": "Explore spacious two bedroom apartments at Rena Valley, Crawford County. Ideal for families or roommates seeking a larger living space.",
      "page_copy": "At Rena Valley Apartments in Crawford County, you’ll find the perfect two bedroom living solution that offers both space and style. Our two bedroom apartments are designed to accommodate families and roommates alike, providing ample room for privacy and comfort. Each apartment features modern amenities, including a fully equipped kitchen, that cater to daily living needs.\n\nEnjoy the convenience of our location, along with access to desirable community features such as a relaxing pool and a versatile clubhouse. Situated in a charming neighborhood, Rena Valley Apartments provides an inviting atmosphere for its residents. Whether you're relaxing on your balcony or socializing at community events, our two bedroom apartments offer an ideal setting for a fulfilling lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and community amenities in autumn.",
        "public_id": "019d0784-4c71-7312-a0bf-756054899ec7",
        "storage_key": "property/6737460151192636/019d0784-4c71-7312-a0bf-756054899ec7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Crawford County",
      "seo_description": "Discover spacious two bedroom apartments in Crawford County at Rena Valley. Perfect for families or roommates. Visit us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3401"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483290"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4871556"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NCMNTR34"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "479-309-1082"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "479-333-8294"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "479-341-4305"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "479-336-8901"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "479-339-3728"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "479-346-0962"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "479-348-1102"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "479-348-0662"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "479-348-0658"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "479-342-4845"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "479-348-1132"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "479-336-8431"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "479-467-6698"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "479-345-6411"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "479-265-6357"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "479-252-9812"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "479-348-0876"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "479-315-5256"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321304717"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "479-339-8427"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "479-425-4938"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "1ee27f8396e16001"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "479-929-2432"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "479-348-0882"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "479-339-3981"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "479-398-5218"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "479-847-1651"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "479-346-1175"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "479-341-2359"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.livingatrenavalley.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "479-315-5402"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "479-342-4845"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3401",
  "custom_repli_id": "5028483290",
  "custom_realpage_id": "4871556",
  "custom_knock_a_link": "https://www.livingatrenavalley.com?utm_knock=a",
  "custom_knock_g_link": "https://www.livingatrenavalley.com?utm_knock=g",
  "custom_knock_r_link": "https://www.livingatrenavalley.com?utm_knock=r",
  "custom_knock_w_link": "https://www.livingatrenavalley.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-NCMNTR34",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.livingatrenavalley.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.livingatrenavalley.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.livingatrenavalley.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.livingatrenavalley.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.livingatrenavalley.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.livingatrenavalley.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "479-309-1082",
  "custom_knock_ads_link": "https://www.livingatrenavalley.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.livingatrenavalley.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "479-333-8294",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.livingatrenavalley.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.livingatrenavalley.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.livingatrenavalley.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.livingatrenavalley.com?utm_knock=psa",
  "custom_knock_r_number": "479-341-4305",
  "custom_knock_w_number": "479-336-8901",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "479-339-3728",
  "custom_knock_amap_link": "https://www.livingatrenavalley.com?utm_knock=amap",
  "custom_knock_ar_number": "479-346-0962",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "479-348-1102",
  "custom_knock_fb_number": "479-348-0662",
  "custom_knock_fl_number": "479-348-0658",
  "custom_knock_gp_number": "479-342-4845",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.livingatrenavalley.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "479-348-1132",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.livingatrenavalley.com?utm_knock=bcard",
  "custom_knock_bnr_number": "479-336-8431",
  "custom_knock_cfres_link": "https://www.livingatrenavalley.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "479-467-6698",
  "custom_knock_lgp_number": "479-345-6411",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.livingatrenavalley.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "479-265-6357",
  "custom_knock_psa_number": "479-252-9812",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "479-348-0876",
  "custom_knock_bandit_link": "https://www.livingatrenavalley.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.livingatrenavalley.com?utm_knock=flyers",
  "custom_knock_osoc_number": "479-315-5256",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321304717",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "479-339-8427",
  "custom_knock_cfres_number": "479-425-4938",
  "custom_knock_chatgpt_link": "https://www.livingatrenavalley.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "1ee27f8396e16001",
  "custom_knock_dirmail_link": "https://www.livingatrenavalley.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "479-929-2432",
  "custom_knock_propbro_link": "https://www.livingatrenavalley.com?utm_knock=propbro",
  "custom_knock_bandit_number": "479-348-0882",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "479-339-3981",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.livingatrenavalley.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "479-398-5218",
  "custom_knock_dirmail_number": "479-847-1651",
  "custom_knock_propbro_number": "479-346-1175",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "479-341-2359",
  "custom_knock_maintenance_link": "https://www.livingatrenavalley.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_knock_maintenance_number": "479-315-5402",
  "custom_ppc_tracking_phone_number": "479-342-4845"
};

export const generatedAt = '2026-10-07T17:12:40.440Z';
